import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['code'];

  static outlets = ['clipboard'];

  static values = {
    withProducts: String,
    withoutProducts: String,
    teamId: Number,
  };

  clipboardOutletConnected(_outlet, element) {
    element.addEventListener('clipboard:copied', this.#trackCopy);
  }

  clipboardOutletDisconnected(_outlet, element) {
    element.removeEventListener('clipboard:copied', this.#trackCopy);
  }

  toggle({ target }) {
    const code = target.checked ? this.withProductsValue : this.withoutProductsValue;
    this.codeTarget.value = code;
    this.clipboardOutlet.textValue = code;
  }

  track() {
    if (!this.teamIdValue) {
      return;
    }
    window.mixpanel?.track('Design Board Embed Code Copied', { team_id: this.teamIdValue });
  }

  #trackCopy = () => this.track();
}
